module.exports = __webpack_public_path__ + "img/coverText.0cd47d0e.png";